import EditBillPaymentDrawer from './EditBillPaymentDrawer';

export const editBillPaymentDrawerRoute = {
  path: '#/payment/:id',
  component: EditBillPaymentDrawer
};

export default editBillPaymentDrawerRoute;
